export class EntrepriseEngagement {
    static jsonMap = {
        id: { key: 'id', optional: true },
        raisonSociale: { key: 'raisonSociale' },
        adresse: { key: 'adresse', optional: true, default: '' },
        codePostal: { key: 'codePostal', optional: true, default: '' },
        commune: { key: 'commune', optional: true, default: '' },
        departement: { key: 'departement', optional: true, default: '' },
        siret: { key: 'siret', optional: true, default: '' },
        telephone: { key: 'telephone', optional: true, default: '' },
        mail: { key: 'mail', optional: true, default: '' },
        sousType: { key: 'sousType', optional: true, default: '' }
    };

    public id: number = undefined;
    public raisonSociale: string = undefined;
    public adresse: string = undefined;
    public codePostal: string = undefined;
    public commune: string = undefined;
    public departement: string = undefined;
    public siret: string = undefined;
    public telephone: string = undefined;
    public mail: string = undefined;
    public sousType: string = undefined;
}
